var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 20a1 1 0 01-1 1H4.568c-.252 0-.498 0-.706-.017a2.022 2.022 0 01-.77-.201 2 2 0 01-.874-.874 2.022 2.022 0 01-.201-.77C2 18.93 2 18.684 2 18.432V5.568c0-.252 0-.498.017-.706.019-.229.063-.499.201-.77a2 2 0 01.874-.874c.271-.138.541-.182.77-.201C4.07 3 4.316 3 4.568 3H11a1 1 0 110 2H4.6c-.297 0-.459 0-.575.01l-.014.001v.014C4 5.14 4 5.303 4 5.6v12.8c0 .297 0 .459.01.575l.001.013.014.002c.116.01.278.01.575.01H11a1 1 0 011 1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.243 9.121a1 1 0 011.414-1.414l3.535 3.535a1 1 0 010 1.415l-3.535 3.535a1 1 0 11-1.414-1.414L17.02 13H8a1 1 0 110-2h9.121L15.243 9.12z"
  })));
}
export default SvgLogout;